// extracted by mini-css-extract-plugin
export default {"App":"Typography_App__4o6Iz","uppercase":"Typography_uppercase__mRNn-","text":"Typography_text__HiXc2","small":"Typography_small__EcLo2","label":"Typography_label__4VcDl"};